import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { FailState } from "../../models/fail-state";
import { ProposalsState } from "../../models/proposals-state";
import { AppState } from "../../reducers";
import { ProposalSelectors } from "../../selectors/proposal.selectors";

@Injectable()
export class ProposalFinancialGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.financials.get),
			withLatestFrom(this.store.select(ProposalSelectors.financials)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(OrderProposalActions.financials.getSuccess(state))
					: of(OrderProposalActions.financials.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(
				OrderProposalActions.financials.getApi,
				OrderProposalActions.acceptProposal.acceptSuccess
			),
			switchMap(() => {
				return this.proposalService.allProposalFinancials().pipe(
					map((proposals) =>
						OrderProposalActions.financials.getSuccess({
							proposals,
							loading: false,
							allRetrieved: true
						})
					),
					catchError((error) =>
						of(OrderProposalActions.financials.getFail(new FailState(error)))
					)
				);
			})
		)
	);

	constructor(
		private actions: Actions,
		private proposalService: OrderProposalService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: ProposalsState): boolean {
		return !_.has(state, "error") && !state.loading && state.allRetrieved;
	}
}
